module.exports = "/_next/static/images/f972c23de9de64c27fec24c010238a3d-app-screenshots-md@1x.jpg.webp";